module.exports = __webpack_public_path__ + "img/history.e62be711.png";